export const CELL_MATCH_MODE_EQUALS = "eq";
export const CELL_MATCH_MODE_CONTAINS = "ct";
export const CELL_MATCH_MODE_NOT_EQUALS = "ne";
export const CELL_MATCH_MODE_NOT_CONTAINS = "nc";

export const CELL_MATCH_MODE_OPTIONS = [
  { value: CELL_MATCH_MODE_EQUALS, label: "EQUALS" },
  { value: CELL_MATCH_MODE_CONTAINS, label: "CONTAINS" },
  { value: CELL_MATCH_MODE_NOT_EQUALS, label: "NOT" },
  { value: CELL_MATCH_MODE_NOT_CONTAINS, label: "NOT CONTAINS" },
];

export const normalizeCellMatchMode = (mode) => {
  const normalized = String(mode || CELL_MATCH_MODE_EQUALS).trim().toLowerCase();
  if (normalized === CELL_MATCH_MODE_CONTAINS || normalized === "contains" || normalized === "like" || normalized === "partial") {
    return CELL_MATCH_MODE_CONTAINS;
  }
  if (normalized === CELL_MATCH_MODE_NOT_EQUALS || normalized === "not" || normalized === "neq" || normalized === "noteq") {
    return CELL_MATCH_MODE_NOT_EQUALS;
  }
  if (normalized === CELL_MATCH_MODE_NOT_CONTAINS || normalized === "not_contains" || normalized === "notcontains" || normalized === "nct") {
    return CELL_MATCH_MODE_NOT_CONTAINS;
  }
  return CELL_MATCH_MODE_EQUALS;
};

export const cellValueIsBlank = (value) => {
  if (value == null) {
    return true;
  }
  if (typeof value === "boolean") {
    return false;
  }
  return String(value).trim() === "";
};

export const valuesMatchByMode = (cellValue, ruleValue, mode = CELL_MATCH_MODE_EQUALS) => {
  const normalizedMode = normalizeCellMatchMode(mode);
  const expected = ruleValue == null ? "" : String(ruleValue).trim();

  if (expected === "") {
    if (normalizedMode === CELL_MATCH_MODE_NOT_EQUALS || normalizedMode === CELL_MATCH_MODE_NOT_CONTAINS) {
      return !cellValueIsBlank(cellValue);
    }
    return cellValueIsBlank(cellValue);
  }

  const cellText = String(cellValue ?? "").trim();
  if (normalizedMode === CELL_MATCH_MODE_CONTAINS) {
    return cellText.toLowerCase().includes(expected.toLowerCase());
  }
  if (normalizedMode === CELL_MATCH_MODE_NOT_CONTAINS) {
    return !cellText.toLowerCase().includes(expected.toLowerCase());
  }
  if (normalizedMode === CELL_MATCH_MODE_NOT_EQUALS) {
    return cellText !== expected;
  }
  return cellText === expected;
};

export const formatMatchModeLabel = (mode) => {
  const normalized = normalizeCellMatchMode(mode);
  if (normalized === CELL_MATCH_MODE_CONTAINS) {
    return "CONTAINS";
  }
  if (normalized === CELL_MATCH_MODE_NOT_EQUALS) {
    return "NOT";
  }
  if (normalized === CELL_MATCH_MODE_NOT_CONTAINS) {
    return "NOT CONTAINS";
  }
  return "EQUALS";
};
